<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg117"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs121"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath131"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path129" /></clipPath></defs><g
     id="g123"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g125"><g
         id="g127"
         clip-path="url(#clipPath131)"><g
           id="g133"
           transform="translate(413.7598,55.5898)"><path
             d="m 0,0 v -28.09 c 0,-11.05 -8.96,-20 -20,-20 h -50.52 c -11.04,0 -20,8.95 -20,20 v 28"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path135" /></g><g
           id="g137"
           transform="translate(188.7598,55.5)"><path
             d="m 0,0 v -28 c 0,-11.05 -8.96,-20 -20,-20 h -50.52 c -11.04,0 -20,8.95 -20,20 V 0.09"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path139" /></g><g
           id="g141"
           transform="translate(70.4995,333.6509)"><path
             d="m 0,0 v 98.849 c 0,16.568 13.432,30 30,30 h 311.001 c 16.568,0 30,-13.432 30,-30 v -347 c 0,-16.568 -13.432,-30 -30,-30 H 30 c -16.568,0 -30,13.432 -30,30 V -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path143" /></g><g
           id="g145"
           transform="translate(133.9785,462.5)"><path
             d="m 0,0 v 22 c 0,11.046 8.955,20 20,20 h 204.043 c 11.045,0 20,-8.954 20,-20 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path147" /></g><g
           id="g149"
           transform="translate(401.5005,216.4678)"><path
             d="m 0,0 h -291.001 c -5.523,0 -10,4.477 -10,10 v 166.032 c 0,5.523 4.477,10 10,10 H 0 c 5.523,0 10,-4.477 10,-10 V 10 C 10,4.477 5.523,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path151" /></g><g
           id="g153"
           transform="translate(385.5215,432.5)"><path
             d="m 0,0 c 0,-4.142 -3.358,-7.5 -7.5,-7.5 -4.142,0 -7.5,3.358 -7.5,7.5 0,4.142 3.358,7.5 7.5,7.5 C -3.358,7.5 0,4.142 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path155" /></g><g
           id="g157"
           transform="translate(141.4785,432.5)"><path
             d="m 0,0 c 0,-4.142 -3.358,-7.5 -7.5,-7.5 -4.142,0 -7.5,3.358 -7.5,7.5 0,4.142 3.358,7.5 7.5,7.5 C -3.358,7.5 0,4.142 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path159" /></g><g
           id="g161"
           transform="translate(176.1841,432.5)"><path
             d="M 0,0 H 159.632"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path163" /></g><g
           id="g165"
           transform="translate(303.646,171.4678)"><path
             d="m 0,0 h 31.573 c 4.335,0 7.239,-4.457 5.489,-8.423 L 12.358,-64.395 c -0.96,-2.174 -3.112,-3.577 -5.489,-3.577 h -109.03 c -2.377,0 -4.529,1.403 -5.489,3.577 l -24.704,55.972 C -134.104,-4.457 -131.2,0 -126.865,0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path167" /></g><g
           id="g169"
           transform="translate(441.5005,103.4961)"><path
             d="m 0,0 h -78.965 c -1.437,0 -2.405,1.469 -1.838,2.789 l 15.758,36.709 c 1.104,2.572 3.634,4.239 6.433,4.239 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path171" /></g><g
           id="g173"
           transform="translate(70.4995,103.4961)"><path
             d="m 0,0 h 78.965 c 1.437,0 2.405,1.469 1.838,2.789 L 65.045,39.498 c -1.104,2.572 -3.634,4.239 -6.433,4.239 L 0,43.737"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path175" /></g><g
           id="g177"
           transform="translate(497.5,296.5)"><path
             d="m 0,0 h -16 c -3.866,0 -7,3.134 -7,7 v 99 H 0 c 3.866,0 7,-3.134 7,-7 V 7 C 7,3.134 3.866,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path179" /></g><g
           id="g181"
           transform="translate(474.5,402.5)"><path
             d="M 0,0 H -33"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path183" /></g><g
           id="g185"
           transform="translate(14.5,296.5)"><path
             d="m 0,0 h 16 c 3.866,0 7,3.134 7,7 v 99 H 0 c -3.866,0 -7,-3.134 -7,-7 V 7 C -7,3.134 -3.866,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path187" /></g><g
           id="g189"
           transform="translate(37.5,402.5)"><path
             d="M 0,0 H 33"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path191" /></g><g
           id="g193"
           transform="translate(221.269,137.4819)"><path
             d="M 0,0 H 69.462"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path195" /></g></g></g></g></svg>
</template>
